import qs from "qs-lite";
import { useQuery } from "react-query";
import api from "../../utils/api";

const GOOGLE = "/google";

const getGoogleAddressList = (input) => {
  const queryString = qs.stringify({ input });
  return api.get(`${GOOGLE}/address?${queryString}`);
};

export const useGetGoogleAddressList = (input) => {
  return useQuery([`${GOOGLE}/address`], () => getGoogleAddressList(input), {
    enabled: !!input,
  });
};
